export default __webpack_public_path__ + "static/media/Ass 9.43ed8d51.png";